import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import { config } from './1mind.config';
let excludedPaths = [];
export function isOnemindAllowed(oneMindProperties) {
    return (!envFlags.getValue(FLAGS.e2eTest.name) &&
        !oneMindProperties.isEmbeddedUseCase &&
        !oneMindProperties.isPrintPage &&
        !oneMindProperties.isEmbedded);
}
const has1mindInitialized = () => {
    const iframeParentDiv = document.querySelector('[id="onemind-widget"]');
    return !!(iframeParentDiv && iframeParentDiv?.querySelector('iframe'));
};
export const hideOneMindBot = (hideOneMindBot) => {
    const iframeParentDiv = document.querySelector('[id="onemind-widget"]');
    if (iframeParentDiv) {
        iframeParentDiv.style.display = hideOneMindBot ? 'none' : '';
    }
};
export const close1mindBot = () => {
    document
        .querySelector('script[src^="https://launcher.1mind.com"]')
        ?.remove();
};
export const init1mind = (oneMindProperties) => {
    excludedPaths = oneMindProperties?.excludedPaths;
    const currentPath = oneMindProperties?.currentPath;
    if (isOnemindAllowed(oneMindProperties) && !has1mindInitialized()) {
        let widgetDiv = document.getElementById('onemind-widget');
        if (!widgetDiv) {
            widgetDiv = document.createElement('div');
            widgetDiv.id = 'onemind-widget';
            document.body.appendChild(widgetDiv);
        }
        const script = document.createElement('script');
        script.defer = config.defer;
        script.src = `https://launcher.1mind.com/${oneMindProperties?.vaultToken}`;
        script.setAttribute('data-display_mode', config.dataDisplayMode);
        script.setAttribute('data-firstName', oneMindProperties?.firstName);
        script.setAttribute('data-lastName', oneMindProperties?.lastName);
        script.setAttribute('data-email', oneMindProperties?.userEmail);
        script.setAttribute('data-cdw', oneMindProperties?.cdw);
        script.setAttribute('data-role', oneMindProperties?.role);
        script.setAttribute('data-company', oneMindProperties?.company);
        const x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(script, x);
        script.onload = () => {
            hideOneMindBot(excludedPaths.some(path => currentPath.startsWith(path)));
        };
    }
};
//# sourceMappingURL=1mind.js.map